<main class="quick" aria-live="polite">
  @if (loginFailed) {
    <h1>We couldn't finish signing you in</h1>
    <p>Please check your connection and try again.</p>
    <button type="button" (click)="retryLogin()">Try again</button>
    <a routerLink="/login">Sign in another way</a>
  } @else {
    <h1>Signing you in</h1>
    <p>Please wait while we open your account.</p>
  }
</main>
